export default "__VITE_ASSET__3hZOHpsV__"